// extracted by mini-css-extract-plugin
module.exports = {"videoMaterials":"VideoDocument_videoMaterials__YL5zp","videoMaterialsList":"VideoDocument_videoMaterialsList__by0iM","icon":"VideoDocument_icon__2xjRy"};